import {createSelector} from 'reselect';
import {getBadges} from './listing';

const BADGE_GROUP_IDS = {
    partnerBadges: '1',
    amenities: '3',
    reviews: '2',
    segmentation: '5'
};

const BADGE_IDS = {
    familyFriendly: '21',
    premierPartner: '1'
};

const getBadgeGroups = createSelector([getBadges], (badges) => {
    const badgeGroupsObj = badges.find((obj) => obj.badgeGroups);
    const badgeGroups = badgeGroupsObj && badgeGroupsObj.badgeGroups;
    return badgeGroups || [];
});

const getAmenitiesBadges = createSelector([getBadgeGroups], (badgeGroups) => {
    const amenitiesBadgesObj = badgeGroups.find((group) => (group.id === BADGE_GROUP_IDS.amenities));
    const amenitiesBadges = amenitiesBadgesObj && amenitiesBadgesObj.badges;
    return amenitiesBadges || [];
});

const getSegmentationBadges = createSelector([getBadgeGroups], (badgeGroups) => {
    const segmentationBadgesObj = badgeGroups.find((group) => (group.id === BADGE_GROUP_IDS.segmentation));
    const segmentationBadges = segmentationBadgesObj && segmentationBadgesObj.badges;
    return segmentationBadges || [];
});

const getPartnerBadges = createSelector([getBadgeGroups], (badgeGroups) => {
    const partnerBadgesObj = badgeGroups.find((group) => (group.id === BADGE_GROUP_IDS.partnerBadges));
    const partnerBadges = partnerBadgesObj && partnerBadgesObj.badges;
    return partnerBadges || [];
});

const getFamilyFriendlyBadge = createSelector([getSegmentationBadges], (segmentationBadges) => {
    const familyFriendlyBadge = segmentationBadges.find((badge) => (badge.id === BADGE_IDS.familyFriendly));
    return familyFriendlyBadge || {};
});

const getPremierPartnerBadge = createSelector([getPartnerBadges], (partnerBadges) => {
    const premierPartnerBadge = partnerBadges.find((badge) => (badge.id === BADGE_IDS.premierPartner));
    return premierPartnerBadge || {};
});

const getAllBadges = createSelector(
    [getFamilyFriendlyBadge, getPremierPartnerBadge],
    (familyFriendlyBadge, premierPartnerBadge) => {
        return {
            familyFriendlyBadge,
            premierPartnerBadge
        };
    }
);

export default getAllBadges;
export {
    getAllBadges,
    getAmenitiesBadges,
    getBadgeGroups,
    getFamilyFriendlyBadge,
    getPartnerBadges,
    getPremierPartnerBadge,
    getSegmentationBadges
};
